export const UserRoleTypes = Object.freeze({
    super_admin: 'Super Admin',
    user: 'User',
    organization_admin: 'Organization Admin',
    project_admin: 'Project Admin',
});
